module.exports = __webpack_public_path__ + "img/thumbnail.ccb60199.jpg";